/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Complete_ToastInputs */

const en_ocr_complete_toast = /** @type {(inputs: Ocr_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR analysis complete.`)
};

const fr_ocr_complete_toast = /** @type {(inputs: Ocr_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse OCR terminée.`)
};

const de_ocr_complete_toast = /** @type {(inputs: Ocr_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR-Analyse abgeschlossen.`)
};

const it_ocr_complete_toast = /** @type {(inputs: Ocr_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi OCR completata.`)
};

const ru_ocr_complete_toast = /** @type {(inputs: Ocr_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ OCR завершен.`)
};

const es_ocr_complete_toast = /** @type {(inputs: Ocr_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis OCR completado.`)
};

const zh_cn2_ocr_complete_toast = /** @type {(inputs: Ocr_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR分析完成。`)
};

const ja_ocr_complete_toast = /** @type {(inputs: Ocr_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR分析が完了しました。`)
};

const hi_ocr_complete_toast = /** @type {(inputs: Ocr_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओसीआर विश्लेषण पूर्ण हो गया।`)
};

const pt_pt2_ocr_complete_toast = /** @type {(inputs: Ocr_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise OCR concluída.`)
};

/**
* | output |
* | --- |
* | "OCR analysis complete." |
*
* @param {Ocr_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_complete_toast = /** @type {((inputs?: Ocr_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_complete_toast(inputs)
	if (locale === "de") return de_ocr_complete_toast(inputs)
	if (locale === "it") return it_ocr_complete_toast(inputs)
	if (locale === "ru") return ru_ocr_complete_toast(inputs)
	if (locale === "es") return es_ocr_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_complete_toast(inputs)
	if (locale === "ja") return ja_ocr_complete_toast(inputs)
	if (locale === "hi") return hi_ocr_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_complete_toast(inputs)
	return en_ocr_complete_toast(inputs)
});